import Downshift from 'downshift'
import { useEffect, useState } from 'react'
import {useDispatch } from 'react-redux'
import { itemsFetchData } from '../../redux/items'
import { suggestions } from '../../data/suggestions'
import {ReadSearchTipsLink} from "../ReadSearchTipsLink";

function SearchForm() {
  const [inputValue, setInputValue] = useState(App.State.keywords)
  const [escapedInput, setEscapedInput] = useState(App.State.keywords)
  const [unparsedKeywords, setUnparsedKeywords] = useState(
    App.State.unparsedKeywords
  )
  const [submitting, setSubmitting] = useState(false)
  const [searchSuggestions, setSearchSuggestions] = useState(suggestions)

  const dispatch = useDispatch()

  const fetchData = (filters, options = {}) =>
    dispatch(itemsFetchData({ filters, options }))

  const submitFilters = (parsedFilters, keywords) => {
    const newFilters = parsedFilters
    newFilters.popstate = 0
    newFilters.keywords = keywords

    fetchData(newFilters, { clearAll: true })
  }

  const handleSubmit = (value) => {
    if (!value) {
      fetchData({}, { clearAll: true })
      return
    }

    setSubmitting(true)

    App.Request.post('/cars/parse_keywords.json', {
      keywords: value,
    }).then(({ status, data }) => {
      if (status === 200) {
        setUnparsedKeywords(data.unparsed_keywords)
        setSubmitting(false)

        submitFilters(data.parsed_filters, value)
      }
    })
  }

  const clearInput = () => {
    setInputValue('')
    setUnparsedKeywords('')

    fetchData({}, { clearAll: true })
  }

  useEffect(() => {
    const escapedInputValue = inputValue.replace(
      /[-\/\\^$*+?.()|[\]{}]/g,
      '\\$&'
    )

    setSearchSuggestions(
      inputValue
        ? suggestions.filter(
            (item) =>
              !inputValue || new RegExp(escapedInputValue, 'gi').test(item)
          )
        : suggestions
    )

    setEscapedInput(escapedInputValue)
  }, [inputValue])

  return (
    <Downshift
      onChange={(selection) => {
        setInputValue(selection)
        handleSubmit(selection)
        App.GAEvent('Cars Search', 'Click Search Suggestion')
      }}
    >
      {({ getInputProps, getItemProps, getMenuProps, isOpen, openMenu, highlightedIndex }) => (
        <div className="position-relative mb-2">
          <div className="d-block w-100">
            <div className="input-group search rounded-8">
              <input
                {...getInputProps({
                  type: 'text',
                  className:
                    'form-control typewriter text-dark border-0 rounded-left-8',
                  'data-controller': 'typewriter',
                  value: inputValue,
                  onChange: (e) => {
                    setInputValue(e.target.value)
                  },
                  disabled: submitting,
                  onKeyPress: (e) => {
                    e.key === 'Enter' && handleSubmit(inputValue)
                  },
                  onFocus: () => openMenu(),
                })}
              />

              {inputValue && (
                <button
                  className="btn btn-link text-secondary bg-white"
                  onClick={clearInput}
                  type="button"
                >
                  <i className="fa fa-times" />
                </button>
              )}

              <button
                className="btn btn-white px-4 h-100 rounded-right-8"
                type="button"
                onClick={() => handleSubmit(inputValue)}
                disabled={submitting}
              >
                <i className="fas fa-search fa-fw me-1" />
                <span className="d-none d-lg-inline-block font-weight-bold">
                  {I18n.t('search.search')}
                </span>
              </button>
            </div>
            {/* {unparsedKeywords && ( */}
            {/*   <div className="mt-1"> */}
            {/*     <span className="text-dark me-1"> */}
            {/*       {I18n.t('excluded_keywords')}: {unparsedKeywords} - */}
            {/*     </span> */}
            {/*     <ReadSearchTipsLink /> */}
            {/*   </div> */}
            {/* )} */}
          </div>
          {isOpen && searchSuggestions.length > 0 && (
            <div
              {...getMenuProps()}
              className="text-start bg-white text-dark p-3 cursor-pointer border rounded position-absolute auto-select-container shadow"
            >
              {searchSuggestions.map((item, index) => (
                <div
                  {...getItemProps({
                    item,
                    key: item,
                  })}
                  className={`p-2 auto-select-option ${highlightedIndex === index ? 'selected-search-option' : ""}`}
                  style={{ cursor: 'pointer' }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.replace(
                        new RegExp(`(${escapedInput})`, 'gi'),
                        '<b>$1</b>'
                      ),
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </Downshift>
  )
}

export default SearchForm
